import React from "react";
import {
  Drawer,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import ArticlesSidebar from "../../assets/icons/Articlesidebar.svg";
import ScriptsSidebar from "../../assets/icons/ScriptsSidebar.svg";
import VideosSidebar from "../../assets/icons/VideosSidebar.svg";
import ArticlesSidebarHover from "../../assets/icons/ArticlesidebarHover.svg";
import ScriptsSidebarHover from "../../assets/icons/ScriptsSidebarHover.svg";
import VideosSidebarHover from "../../assets/icons/VideosSidebarHover.svg";
import { logout } from "../../utils/auth";
const drawerWidth = 240;

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      text: "Articles",
      path: "/articles",
      icon: ArticlesSidebar,
      activeIcon: ArticlesSidebarHover,
      width: 16,
      height: 16,
    },
    {
      text: "Scripts",
      path: "/scripts",
      icon: ScriptsSidebar,
      activeIcon: ScriptsSidebarHover,
      width: 22.29,
      height: 22.29,
    },
    {
      text: "Videos",
      path: "/videos",
      icon: VideosSidebar,
      activeIcon: VideosSidebarHover,
      width: 18,
      height: 12,
    },
  ];

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login"); // Redirect to login page after logout
    } catch (error) {
      console.error("Logout failed:", error);
      // You might want to show an error message to the user
    }
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: "230px",
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: "240px",
          boxSizing: "border-box",
          borderRight: "1px solid #e0e0e0",
        },
      }}
    >
      <Box
        sx={{
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "50px",
        }}
      ></Box>

      <List
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          const currentIcon = isActive ? item.activeIcon : item.icon;

          return (
            <Link
              key={item.text}
              to={item.path}
              style={{
                textDecoration: "none",
                color: "#161616",
                width: "220px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ListItemButton
                selected={isActive}
                disableRipple={true}
                sx={{
                  height: "52px",
                  width: "220px",
                  justifyContent: "flex-start",
                  cursor: "pointer",
                  "&.Mui-selected": {
                    backgroundColor: "#4691E11A",
                    borderRadius: "15px",
                  },
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <ListItemIcon>
                  <img
                    src={currentIcon}
                    alt={item.text}
                    style={{ width: item.width, height: item.height }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  sx={{
                    "& .MuiTypography-root": {
                      color: isActive ? "#161616" : "#161616",
                    },
                  }}
                />
              </ListItemButton>
            </Link>
          );
        })}
      </List>

      <Divider sx={{ mt: "auto" }} />

      <Box sx={{ p: 2, mb: 10, borderBottom: "1px solid #e0e0e0" }}>
        <ListItemButton
          onClick={handleLogout}
          disableRipple={true}
          sx={{
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <ListItemIcon>
            <LogoutIcon sx={{ color: "red" }} />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </Box>
    </Drawer>
  );
}

export default Sidebar;
